import { fetchPostJson } from '@mmt/core/network';
import railsConfig from '../../RailsConfig';
import {getRailsLanguageByKey} from '../../vernacular/AppLanguage';

export const getDataFromConfigStore = async (configKey, isConfigList = false) => {
  const url = railsConfig.configStoreUrl;
  const header = {
    Accept: 'application/json, text/plain, */*',
    Authorization: 'Tect685j8xMpLJF',
    'Content-Type': 'application/json',
    'Accept-Language': 'en-GB,en-US;q=0.9,en;q=0.8',
    language: getRailsLanguageByKey("cookieCode"),
  };
  const request = isConfigList
    ? {
        cfgKeyList: configKey,
      }
    : {
    cfgKey: configKey,
    status: 'ACTIVE',
  };
  const response = await fetchPostJson(
    url,
    request,
    header,
  );
  return response;
};


